<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>保障级别管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" size="small" @click="loadTableData">刷新</el-button>
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增</el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="levelName" align="center" label="保障级别名称"></el-table-column>

        <el-table-column prop="discountRate" align="center" label="农副产品折扣">
          <template slot-scope="scope">{{ scope.row.discountRate || "-" }}</template>
        </el-table-column>

        <el-table-column prop="rushBuyStartTime" align="center" label="抢购时间">
          <template slot-scope="{ row }">
            自发布菜品时起{{ row.rushBuyStartMinute || "-" }}
            {{ rushBuyStartTimeTypeList[row.rushBuyStartTimeType] }}
          </template>
        </el-table-column>

        <el-table-column prop="description" align="center" label="描述">
          <template slot-scope="{ row }">{{ row.description || "-" }} </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>

            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该保障级别？" @confirmed="handleDelete(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <!--编辑 dialog-->
    <el-dialog class="hx-to-create-template" :title="levelParams.id ? '编辑保障级别' : '新增保障级别'" :visible.sync="dialogVisible" width="56%" @close="resetDialogForm" :close-on-click-modal="false">
      <el-form ref="dialogForm" :model="levelParams" :rules="checkLevelParams" label-width="120px">
        <el-form-item label="级别名称：" prop="levelName">
          <el-input placeholder="请输入级别名称" v-model="levelParams.levelName" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="农副产品折扣：" prop="discountRate">
          <el-input-number v-model="levelParams.discountRate" :precision="2" :step="0.1" :min="0" :max="10" />
          <span class="mgl10">折</span>
        </el-form-item>

        <el-form-item label="首次库存比例" prop="stockProportion">
          <el-input-number v-model="levelParams.stockProportion" :precision="1" :step="1" :min="0" :max="100" />
          <span class="mgl10">%</span>
        </el-form-item>

        <el-form-item label="补菜库存比例" prop="replenishStockProportion">
          <el-input-number v-model="levelParams.replenishStockProportion" :precision="1" :step="1" :min="0" :max="100" />
          <span class="mgl10">%</span>
        </el-form-item>

        <el-form-item label="时间" prop="rushBuyStartTimeType">
          <template>
            <el-radio v-model.number="levelParams.rushBuyStartTimeType" :label="10">时</el-radio>
            <el-radio v-model.number="levelParams.rushBuyStartTimeType" :label="20">分钟</el-radio>
            <el-radio v-model.number="levelParams.rushBuyStartTimeType" :label="30">天</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="购买时段：" prop="rushBuyStartMinute">
          <el-input style="width: 220px" v-model="levelParams.rushBuyStartMinute" placeholder="请输入购买时段"> </el-input>
          <span class="mgl10">{{ rushBuyStartTimeTypeList[levelParams.rushBuyStartTimeType] }}</span>
          <span style="color: #f56c6c; padding-left: 10px">
            <i class="el-icon-info"></i>
            菜品发布当日生效
          </span>
        </el-form-item>
        <el-form-item>
          <p style="color: red">
            1、购买时段，可设置每个领货日往后延多少
            {{ rushBuyStartTimeTypeList[levelParams.rushBuyStartTimeType] }}
            ，才允许其当前用户库进行菜品售卖
          </p>
          <p style="color: red">2、默认为“0”时，即领货日即可购买</p>
        </el-form-item>

        <el-form-item label="描述：" prop="description">
          <el-input type="textarea" placeholder="请输入描述" v-model="levelParams.description" maxlength="60"></el-input>
        </el-form-item>

        <div class="align-center">
          <el-button :disabled="isDisabled" size="small" type="primary" @click="handleSave()">保 存</el-button>

          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const defaultLevelParams = {
  id: "",
  levelName: "",
  discountRate: 0,
  rushBuyStartTime: "",
  rushBuyEndTime: "",
  rushBuyStartTimeType: 10,
  stockProportion: 0,
  replenishStockProportion: 0,
};
export default {
  data() {
    return {
      tableLoading: false,
      supplyId: "",
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      levelParams: Object.assign({}, defaultLevelParams),
      dialogVisible: false,
      isDisabled: false,
      checkLevelParams: {
        levelName: [{ required: true, message: "请输入级别名称", trigger: "blur" }],
        rushBuyStartTimeType: [{ required: true, message: "请选择时间单位", trigger: "blur" }],
        rushBuyStartMinute: [
          { required: true, message: "请输入购买时段", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (/^(0|\+?[1-9][0-9]*)$/.test(value)) {
                callback();
              } else {
                callback(new Error("请输入正整数"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      rushBuyStartTimeTypeList: {
        10: "小时",
        20: "分钟",
        30: "天",
      },
    };
  },
  mounted() {
    this.supplyId = this.$route.params.supplyId || "";
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/supply/level",
        method: "GET",
        params: {
          supplyId: this.supplyId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 新增
     */
    toCreate() {
      this.levelParams = Object.assign({}, defaultLevelParams);
      console.log(this.levelParams);
      this.dialogVisible = true;
    },
    /**
     * 编辑
     */
    handleEdit(rowData) {
      this.levelParams = Object.assign({}, defaultLevelParams, rowData);
      this.dialogVisible = true;
    },
    /**
     * 保存新增或修改
     */
    handleSave() {
      this.isDisabled = true;
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          this.$http({
            url: this.levelParams.id ? global.apiUrl + "/supply/editLevel" : global.apiUrl + "/supply/saveLevel",
            method: this.levelParams.id ? "PUT" : "POST",
            body: Object.assign({}, this.levelParams, {
              // rushBuyEndTime暂时保留
              rushBuyEndTime: this.levelParams.rushBuyStartTime,
            }),
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
              }
              setTimeout(() => {
                this.isDisabled = false;
              }, 500);
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 删除
     */
    handleDelete(id) {
      this.$http({
        url: global.apiUrl + `/supply/deleteLevel/${id}`,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
.text {
  margin: 0 6px;
}
</style>
